import React from 'react';

import { Button } from '@infoods/lifebase-ui';
import DownloadIcon from '@mui/icons-material/FileDownloadOutlined';

import classes from './HistoryItemRow.module.scss';
import { ScanIqPaymentHistoryRecord } from '../../../../interfaces/scanIqPaymentHistoryList';
import {
  GridTableCell,
  GridTableRow,
  PriceCell,
} from '../../../../../shared/components/table-components';
import { getFormattedDate } from '../../../../../shared/utils/dateUtils';
import { localDataFormat } from '../../../../../shared/constants/apiDateFormat';
import { BillingPeriodTypeChip } from '../../../../components/BillingPeriodTypeChip/BillingPeriodTypeChip';
import { StatusCell } from '../../../../components/StatusCell/StatusCell';
import { DiscountChip } from '../../../../components/DiscountChip/DiscountChip';

type HistoryItemRowProps = {
  historyRecord: ScanIqPaymentHistoryRecord;
};

const HistoryItemRow = ({ historyRecord }: HistoryItemRowProps) => {
  const {
    paymentDate,
    subscriptionName,
    billingPeriodType,
    totalAmountCents,
    totalExcludingTaxCents,
    discountPercent,
    status,
    invoicePdfUrl,
  } = historyRecord;

  return (
    <GridTableRow variant="subRow" className={classes.historyItemRow}>
      <GridTableCell>{getFormattedDate(paymentDate, localDataFormat)}</GridTableCell>
      <GridTableCell>
        <div className={classes.subscriptionNameCell}>
          {subscriptionName}
          <DiscountChip
            show={!!discountPercent}
            discountPercent={discountPercent}
            className="private-info"
          />
        </div>
      </GridTableCell>
      <GridTableCell>
        <BillingPeriodTypeChip billingPeriodType={billingPeriodType} />
      </GridTableCell>
      <PriceCell price={totalAmountCents / 100} />
      <PriceCell price={totalExcludingTaxCents / 100} />
      <StatusCell status={status} />
      {invoicePdfUrl && (
        <GridTableCell>
          <Button
            size="small"
            startIcon={<DownloadIcon fontSize="small" />}
            href={invoicePdfUrl}
          >
            PDF
          </Button>
        </GridTableCell>
      )}
    </GridTableRow>
  );
};

export { HistoryItemRow };
